import React from 'react';
import { Grid, Typography} from "@material-ui/core";
import '../../App.css'
import './government-styles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';


function GovernmentServices() {
  const globalClasses = globalUseStyles()
  return (
<ThemeProvider theme={theme}>
  <Container className={"governmentServicesStyle"} maxWidth={false} component="section">
    <Grid className={globalClasses.containerVertPadding} container>
      <Grid className={globalClasses.containerSmall} container >
        <Grid item xs={12} md={12}  >
          <Typography variant="h2">Services and Solutions</Typography>
          <Typography variant="body1">We bring innovation and technological advancement to government projects. With a robust skill set, collaborative team structure, and flexible project frameworks, we are prepared to tackle any challenge.  </Typography>
        </Grid>
      </Grid>
    </Grid>
  </Container>
</ThemeProvider>
  );
};

export default GovernmentServices;